import { gql } from '@apollo/client';

export const getBusinessPartnerListWithoutPagination = gql`
  query getBusinessPartnerListWithoutPagination(
    $businessPartnerStatus: [SalesforceManagement_BusinessPartnerStatuses]
  ) {
    SalesforceManagement {
      queries {
        getBusinessPartnerListWithoutPagination(
          SelectedStatuses: $businessPartnerStatus
        ) {
          salesforceManagement_BusinessPartner_Id
          salesforceManagement_BusinessPartner_PersonID {
            views {
              SalesforceManagement_all {
                properties {
                  FullName
                  Email
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getBPPlanListByAssignedLines = gql`
  query getBPPlanListByAssignedLines(
    $selectedBusienssUserID: String!
    $selectedBusinessPartnerID: String!
    $selectedLineID: String!
  ) {
    SalesforceManagement {
      queries {
        getBPPlanListByAssignedLines(
          selectedBusienssUserID: $selectedBusienssUserID
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          selectedLineID: $selectedLineID
          SelectedStatuses: [ACTIVE]
        ) {
          salesforceManagement_BusinessPartnerPlan_Id
          salesforceManagement_BusinessPartnerPlan_ActiveFrom
          salesforceManagement_BusinessPartnerPlan_ActiveTo
          salesforceManagement_BusinessPartnerPlan_PlanID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Name
                }
              }
            }
          }
          salesforceManagement_BusinessPartnerPlan_Status
          salesforceManagement_BusinessPartnerPlan_PlanCommissionType
          salesforceManagement_BusinessPartnerPlan_PlanCommissionValue
          salesforceManagement_BusinessPartnerPlan_ValueCurrency {
            Title
          }
          salesforceManagement_BusinessPartnerPlan_ApplicableOn {
            Title
          }
        }
      }
    }
  }
`;

export const getBPLinesLov = gql`
  query getBPLinesLov($selectedBusinessPartnerID: String) {
    SalesforceManagement {
      queries {
        getBusinessPartnerLinesListWithoutPagination(
          selectedBusinessPartnerID: $selectedBusinessPartnerID
        ) {
          salesforceManagement_BusinessPartnerLine_Id
          salesforceManagement_BusinessPartnerLine_LineID {
            id
            views {
              PlanConfigManagement_all {
                properties {
                  Name
                  ExternalCode
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const createAssignedBPPlan = gql`
  mutation createAssignedBPPlan(
    $selectedBusinessUserID: String!
    $selectedBusinessPartnerID: String!
    $selectedBusinessPartnerLineID: String!
    $selectedBusinessPartnerPlanIDs: [String!]!
  ) {
    salesforceManagement {
      actions {
        createAssignedBPPlan(
          selectedBusinessUserID: $selectedBusinessUserID
          selectedBusinessPartnerID: $selectedBusinessPartnerID
          selectedBusinessPartnerLineID: $selectedBusinessPartnerLineID
          selectedBusinessPartnerPlanIDs: $selectedBusinessPartnerPlanIDs
        ) {
          Items
        }
      }
    }
  }
`;
